import {
    Container,
    Title,
    Text,
    SimpleGrid,
    Paper,
    Progress,
    Stack,
} from "@mantine/core";
import { motion } from "framer-motion";
import classes from "./Skills.module.css";

const containerVariants = {
    hidden: { opacity: 0 },
    visible: {
        opacity: 1,
        transition: {
            staggerChildren: 0.1,
        },
    },
};

const cardVariants = {
    hidden: { scale: 0.8, opacity: 0 },
    visible: {
        scale: 1,
        opacity: 1,
        transition: {
            type: "spring",
            stiffness: 100,
            damping: 15,
        },
    },
};

export function Skills({ data }) {
    return (
        <section className={classes.section} id='skills'>
            <Container size='lg'>
                <motion.div
                    initial={{ opacity: 0, y: 30 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    viewport={{ once: true, amount: 0.3 }}
                    transition={{ duration: 0.6 }}>
                    <Title
                        order={2}
                        className={classes.title}
                        ta='center'
                        mb='xl'>
                        Technologie & Dovednosti
                    </Title>
                </motion.div>

                <motion.div
                    variants={containerVariants}
                    initial='hidden'
                    whileInView='visible'
                    viewport={{ once: true, amount: 0.2 }}>
                    <SimpleGrid cols={{ base: 1, md: 2, lg: 3 }} spacing='xl'>
                        {data.skills.map((category, idx) => (
                            <motion.div key={idx} variants={cardVariants}>
                                <Paper
                                    p='xl'
                                    radius='md'
                                    className={classes.card}>
                                    <Title order={3} size='h4' mb='lg'>
                                        {category.category}
                                    </Title>
                                    <Stack gap='md'>
                                        {category.technologies.map(
                                            (tech, techIdx) => (
                                                <div key={techIdx}>
                                                    <div
                                                        className={
                                                            classes.skillHeader
                                                        }>
                                                        <Text
                                                            size='sm'
                                                            fw={500}>
                                                            {tech.name}
                                                        </Text>
                                                        <Text
                                                            size='sm'
                                                            c='dimmed'>
                                                            {tech.level}%
                                                        </Text>
                                                    </div>
                                                    <Progress
                                                        value={tech.level}
                                                        size='sm'
                                                        radius='xl'
                                                        mt={5}
                                                        classNames={{
                                                            root: classes.progress,
                                                        }}
                                                    />
                                                </div>
                                            )
                                        )}
                                    </Stack>
                                </Paper>
                            </motion.div>
                        ))}
                    </SimpleGrid>
                </motion.div>
            </Container>
        </section>
    );
}
